import { render, staticRenderFns } from "./yellowVPhysician.vue?vue&type=template&id=1afa9682&scoped=true&"
import script from "./yellowVPhysician.vue?vue&type=script&lang=js&"
export * from "./yellowVPhysician.vue?vue&type=script&lang=js&"
import style0 from "./yellowVPhysician.vue?vue&type=style&index=0&id=1afa9682&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1afa9682",
  null
  
)

export default component.exports